import { call, select, takeEvery, put } from 'redux-saga/effects'
import { toastr } from 'react-redux-toastr'
import get from 'lodash/get'

import { getAPIUrl, request } from 'shared/services/networking'
import { sendUnauthenticatedGetRequestToAPI } from 'modules/generators/requestsToAPI'

export const GET_PAYMENT_DATA_REQUEST = 'StripeCheckout/GET_PAYMENT_DATA_REQUEST'
export const GET_PAYMENT_DATA_ERROR = 'StripeCheckout/GET_PAYMENT_DATA_ERROR'
export const GET_PAYMENT_DATA_SUCCESS = 'StripeCheckout/GET_PAYMENT_DATA_SUCCESS'

export const POST_PAYMENT_DATA_REQUEST = 'StripeCheckout/POST_PAYMENT_DATA_REQUEST'
export const POST_PAYMENT_DATA_ERROR = 'StripeCheckout/POST_PAYMENT_DATA_ERROR'
export const POST_PAYMENT_DATA_SUCCESS = 'StripeCheckout/POST_PAYMENT_DATA_SUCCESS'
export const POST_PAYMENT_DATA_REQUIRES_ACTION = 'StripeCheckout/POST_PAYMENT_DATA_REQUIRES_ACTION'

export function getPaymentDataRequest (paymentId) {
  return {
    type: GET_PAYMENT_DATA_REQUEST,
    payload: paymentId
  }
}

export function getPaymentDataError (error) {
  return {
    type: GET_PAYMENT_DATA_ERROR,
    payload: error
  }
}

export function getPaymentDataSuccess (paymentData) {
  return {
    type: GET_PAYMENT_DATA_SUCCESS,
    payload: paymentData
  }
}

export function postPaymentDataRequest (paymentId, tokenId) {
  return {
    type: POST_PAYMENT_DATA_REQUEST,
    payload: {tokenId, paymentId}

  }
}

export function postPaymentDataSuccess (postResponse, paymentAmount) {
  return {
    type: POST_PAYMENT_DATA_SUCCESS,
    meta: {
      analytics: {
        type: 'SEND_EVENT',
        payload: {
          action: 'PAYMENT_CUSTOM_CHECKOUT_SUCCESS',
          category: 'CUSTOM_CHECKOUT',
          trackerName: 'user',
          value: paymentAmount / 100
        }
      },
      facebookPixel: {
        type: 'Purchase',
        payload: {
          value: paymentAmount / 100,
          content_name: 'custom payment',
          currency: 'EUR'
        }
      }
    }
  }
}

export function postPaymentDataError (error) {
  return {
    type: POST_PAYMENT_DATA_ERROR,
    payload: error
  }
}

export function postPaymentDataRequiresAction (intentId) {
  return {
    type: POST_PAYMENT_DATA_REQUIRES_ACTION,
    payload: intentId
  }
}

export const getStripeCheckoutPaymentDataSelector = state => get(state.stripeCheckout.paymentData, 'amount')

export function * getPaymentData (action) {
  const route = `/payment/murfy/${action.payload}/`

  yield call(
    sendUnauthenticatedGetRequestToAPI,
    route,
    getPaymentDataSuccess,
    getPaymentDataError
  )
}

export function * postPaymentData (action) {
  const config = {
    method: 'patch',
    url: `${getAPIUrl()}/payment/murfy/${action.payload.paymentId}/`,
    data: {
      payment_token: action.payload.tokenId
    }
  }
  const paymentAmount = yield select(getStripeCheckoutPaymentDataSelector)

  try {
    const response = yield call(request, config)
    if (response.requires_action && response.payment_intent_client_secret) {
      yield put(postPaymentDataRequiresAction(response.payment_intent_client_secret))
    } else {
      yield put(postPaymentDataSuccess(response, paymentAmount))
    }
  } catch (error) {
    yield put(postPaymentDataError(error))
    yield call(
      toastr.error,
      'Erreur',
      'Le paiement n\'a pas abouti'
    )
  }
}

export function * getPaymentDataSaga () {
  yield takeEvery(GET_PAYMENT_DATA_REQUEST, getPaymentData)
}

export function * postPaymentDataSaga () {
  yield takeEvery(POST_PAYMENT_DATA_REQUEST, postPaymentData)
}

const initialState = {
  error: null,
  isGetPaymentDataErrored: false,
  paymentData: null,
  paymentError: '',
  paymentInProcess: false,
  isPaymentSuccessful: false
}

export function reducer (state = initialState, action) {
  switch (action.type) {
    case GET_PAYMENT_DATA_ERROR:
      return {
        ...state,
        error: action.payload,
        isGetPaymentDataErrored: true
      }
    case GET_PAYMENT_DATA_REQUEST:
      return {
        ...state,
        error: null,
        isGetPaymentDataErrored: false
      }
    case GET_PAYMENT_DATA_SUCCESS:
      return {
        ...state,
        paymentData: action.payload
      }
    case POST_PAYMENT_DATA_REQUEST:
      return {
        ...state,
        error: null,
        paymentInProcess: true,
        paymentError: null
      }
    case POST_PAYMENT_DATA_SUCCESS:
      return {
        ...state,
        paymentInProcess: false,
        isPaymentSuccessful: true,
        intentId: null
      }
    case POST_PAYMENT_DATA_ERROR:
      if (action.payload.data === undefined) {
        return {
          ...state,
          error: action.payload,
          paymentInProcess: false
        }
      } else {
        switch (action.payload.data.code) {
          case 'INVALID_CVC_TRY_AGAIN':
          case 'payment_failed':
            return {
              ...state,
              error: action.payload,
              paymentError: action.payload.data.code,
              paymentInProcess: false
            }
          default:
            return {
              ...state,
              error: action.payload,
              paymentInProcess: false
            }
        }
      }
    case POST_PAYMENT_DATA_REQUIRES_ACTION:
      return {
        ...state,
        intentId: action.payload
      }
    default:
      return state
  }
}

export default reducer
